// extracted by mini-css-extract-plugin
export default {"detail_box":"threeReason_detail_box__9iVMo"};